import { GetMoreContactsForAccountsBtn } from "../ui/GetMoreContactsForAccountsBtn";
import { ProductGoToActionBlock } from "./ProductGoToActionBlock";

export const GetContactsBlock = ({ campaign_id }: { campaign_id: string }) => {
  return (
    <ProductGoToActionBlock
      title="No Contacts Data"
      texts={[
        "Gain buying committee insights by running an up-to-date contact search.",
      ]}
      btn={<GetMoreContactsForAccountsBtn campaign_id={campaign_id} />}
    />
  );
};
